// extracted by mini-css-extract-plugin
module.exports = {"chip":"Chips_styles_chip__9PVMC","activeChip":"Chips_styles_activeChip__21Jkx"};